(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anima-birthday"] && !Shopify.designMode) return;
  try {
    
function initializeAnimaBirthday(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  root.querySelectorAll('[data-version-button]').forEach(button => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-version-button]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelectorAll('[data-version]').forEach(panel => { panel.hidden = panel.dataset.version !== button.dataset.versionButton; });
    });
  });
  const expires = Date.parse(root.dataset.endsAt);
  function refreshExpiry() {
    if (!Number.isFinite(expires) || Date.now() < expires) return;
    root.querySelector('[data-live-offer]').hidden = true;
    root.querySelector('[data-ended-offer]').hidden = false;
    root.querySelector('[data-offer-faq]').hidden = true;
    root.querySelectorAll('form button[type="submit"]').forEach(button => { button.disabled = true; });
  }
  refreshExpiry();
  const interval = setInterval(() => { if (!root.isConnected) clearInterval(interval); else refreshExpiry(); }, 30000);
}
document.querySelectorAll('[data-anima-birthday]').forEach(initializeAnimaBirthday);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-anima-birthday]').forEach(initializeAnimaBirthday));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('ul')
        };

        if (!this.elements.button || !this.elements.panel || !this.elements.input) return;

        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) this.hidePanel();
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class RavStickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      if (!this.header) return;

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.viewportWidth = window.innerWidth;
      this.upDistance = 0;
      this.downDistance = 0;
      this.preventReveal = false;

      this.updateThresholds();
      this.syncAnnouncementOffset();
      this.observeAnnouncement();

      if (this.isMobileLayout) {
        this.resetMobile();
      } else {
        this.measureTrigger();
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.clearTimeout(this.resizeTimer);
      window.clearTimeout(this.preventRevealTimer);
      this.announcementResizeObserver?.disconnect();
      this.announcementMutationObserver?.disconnect();
    }

    syncAnnouncementOffset() {
      const announcement = document.querySelector('.rh-announcement, .rav-announcement, .anima-announcement');
      const announcementSection = announcement?.closest('.shopify-section') || document.querySelector('#shopify-section-announcement-bar');

      let height = 0;

      if (announcementSection && !announcementSection.hidden) {
        const styles = window.getComputedStyle(announcementSection);
        if (styles.display !== 'none' && styles.visibility !== 'hidden') {
          height = Math.round(announcementSection.getBoundingClientRect().height);
        }
      }

      document.documentElement.style.setProperty('--rav-announcement-sticky-offset', `${Math.max(0, height)}px`);
    }

    observeAnnouncement() {
      const announcement = document.querySelector('.rh-announcement, .rav-announcement, .anima-announcement');
      const announcementSection = announcement?.closest('.shopify-section') || document.querySelector('#shopify-section-announcement-bar');
      if (!announcementSection) return;

      if ('ResizeObserver' in window) {
        this.announcementResizeObserver = new ResizeObserver(() => this.syncAnnouncementOffset());
        this.announcementResizeObserver.observe(announcementSection);
      }

      this.announcementMutationObserver = new MutationObserver(() => this.syncAnnouncementOffset());
      this.announcementMutationObserver.observe(announcementSection, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style']
      });
    }

    updateThresholds() {
      this.isMobileLayout = window.matchMedia('(max-width: 1179px)').matches;

      /* Predictable touch behavior: slower to hide, quicker to bring back. */
      this.revealDistance = this.isMobileLayout ? 32 : 72;
      this.hideDistance = this.isMobileLayout ? 56 : 18;
    }

    measureTrigger() {
      const rect = this.header.getBoundingClientRect();
      this.triggerY = rect.top + window.pageYOffset + this.header.offsetHeight;
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        const nextWidth = window.innerWidth;
        this.syncAnnouncementOffset();

        /*
           Mobile browser chrome changes viewport height during scroll.
           Ignore those resize events; only a real width/layout change matters.
        */
        if (Math.abs(nextWidth - this.viewportWidth) < 2) return;

        this.viewportWidth = nextWidth;
        this.updateThresholds();
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.isMobileLayout) {
          this.resetMobile();
        } else {
          this.resetDesktop();
          this.measureTrigger();
        }
      }, 120);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const delta = scrollTop - this.currentScrollTop;

      if (Math.abs(delta) < 1) return;

      if (this.isMobileLayout) {
        this.onMobileScroll(scrollTop, delta);
      } else {
        this.onDesktopScroll(scrollTop, delta);
      }

      this.currentScrollTop = scrollTop;
    }

    onMobileScroll(scrollTop, delta) {
      /* At the actual top, always show the header. */
      if (scrollTop <= 4) {
        this.resetMobile();
        return;
      }

      /* Never move the header while the visitor is using its UI. */
      if (this.isInteractionOpen()) {
        this.revealMobile();
        this.upDistance = 0;
        this.downDistance = 0;
        return;
      }

      if (delta > 0) {
        this.downDistance += delta;
        this.upDistance = 0;

        if (this.downDistance >= this.hideDistance) {
          this.hideMobile();
          this.downDistance = 0;
        }
      } else {
        this.downDistance = 0;

        if (this.preventReveal) {
          this.upDistance = 0;
          window.clearTimeout(this.preventRevealTimer);
          this.preventRevealTimer = window.setTimeout(() => {
            this.preventReveal = false;
          }, 160);
        } else {
          this.upDistance += Math.abs(delta);

          if (this.upDistance >= this.revealDistance) {
            this.revealMobile();
            this.upDistance = 0;
          }
        }
      }
    }

    onDesktopScroll(scrollTop, delta) {
      /* Desktop keeps the deliberate hide/reveal behavior from V8. */
      if (scrollTop <= this.triggerY + 6) {
        this.resetDesktop();
        return;
      }

      if (this.isInteractionOpen()) {
        this.revealDesktop();
        this.upDistance = 0;
        this.downDistance = 0;
        return;
      }

      if (delta > 0) {
        this.downDistance += delta;
        this.upDistance = 0;

        if (this.downDistance >= this.hideDistance) {
          this.hideDesktop();
          this.downDistance = 0;
        }
      } else {
        this.downDistance = 0;

        if (this.preventReveal) {
          this.upDistance = 0;
          window.clearTimeout(this.preventRevealTimer);
          this.preventRevealTimer = window.setTimeout(() => {
            this.preventReveal = false;
          }, 160);
        } else {
          this.upDistance += Math.abs(delta);

          if (this.upDistance >= this.revealDistance) {
            this.revealDesktop();
            this.upDistance = 0;
          }
        }
      }
    }

    isInteractionOpen() {
      return this.header.classList.contains('rav-header-overlay-open') ||
        document.documentElement.classList.contains('rav-menu-open');
    }

    hideMobile() {
      if (this.isInteractionOpen()) return;

      this.header.classList.add('animate', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeMobileDrawer();
    }

    revealMobile() {
      this.header.classList.add('animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    resetMobile() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.upDistance = 0;
      this.downDistance = 0;
      this.preventReveal = false;
    }

    hideDesktop() {
      if (this.isInteractionOpen()) return;

      const wasSticky = this.header.classList.contains('shopify-section-header-sticky');

      if (wasSticky) {
        this.header.classList.add('animate');
      } else {
        /* First transition into sticky mode happens off-screen: do not flash it at the top. */
        this.header.classList.remove('animate');
      }

      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeMobileDrawer();
    }

    revealDesktop() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    resetDesktop() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.upDistance = 0;
      this.downDistance = 0;
      this.preventReveal = false;
    }

    closeMenuDisclosure() {
      const disclosures = this.header.querySelectorAll('details-disclosure');

      disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        } else {
          disclosure.querySelector('details')?.removeAttribute('open');
        }
      });
    }

    closeSearchModal() {
      const modal = this.header.querySelector('details-modal');
      if (modal && typeof modal.close === 'function') modal.close(false);
    }

    closeMobileDrawer() {
      const drawer = this.header.querySelector('.rav-mobile-menu[open]');
      if (drawer) drawer.removeAttribute('open');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', RavStickyHeader);
  }

  function syncRavHeaderLayer() {
    const section = document.getElementById('shopify-section-header');
    if (!section) return;

    const hasOpenLayer = Boolean(
      section.querySelector(
        '.rav-mobile-menu[open], ' +
        '.rav-nav__item--mega > details-disclosure > details[open], ' +
        '.rav-region details[open], ' +
        '.rav-header__search details[open]'
      )
    );

    section.classList.toggle('rav-header-overlay-open', hasOpenLayer);
  }

  function initRavHeader(root = document) {
    const section = document.getElementById('shopify-section-header');

    if (section) {
      section.querySelectorAll('details').forEach((details) => {
        if (details.dataset.ravLayerBound === 'true') return;
        details.dataset.ravLayerBound = 'true';

        details.addEventListener('toggle', () => {
          requestAnimationFrame(syncRavHeaderLayer);
        });
      });
    }

    root.querySelectorAll('.rav-mobile-menu').forEach((drawer) => {
      if (drawer.dataset.ravBound === 'true') return;
      drawer.dataset.ravBound = 'true';

      drawer.addEventListener('toggle', () => {
        const section = document.getElementById('shopify-section-header');

        if (drawer.open) {
          /* Make the header visible before promoting the drawer layer. */
          section?.classList.remove('shopify-section-header-hidden');
          section?.classList.add('rav-header-overlay-open');
          document.documentElement.classList.add('rav-menu-open');
        } else {
          section?.classList.remove('rav-header-overlay-open');
          document.documentElement.classList.remove('rav-menu-open');
        }

        requestAnimationFrame(syncRavHeaderLayer);
      });

      const overlay = drawer.querySelector('.rav-mobile-menu__overlay');
      if (overlay && overlay.dataset.ravScrollGuard !== 'true') {
        overlay.dataset.ravScrollGuard = 'true';
        overlay.addEventListener('touchmove', (event) => event.preventDefault(), { passive: false });
        overlay.addEventListener('wheel', (event) => event.preventDefault(), { passive: false });
      }

      drawer.querySelectorAll('[data-rav-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => drawer.removeAttribute('open'));
      });
    });

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.querySelectorAll('.rav-nav__item--mega > details-disclosure > details').forEach((details) => {
        if (details.dataset.ravHoverBound === 'true') return;
        details.dataset.ravHoverBound = 'true';

        const summary = details.querySelector(':scope > .rav-nav__control');
        const mega = details.querySelector(':scope > .rav-mega');
        if (!summary || !mega) return;

        let closeTimer = null;

        const cancelClose = () => {
          if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
          }
        };

        const openMenu = () => {
          cancelClose();

          document.querySelectorAll('.rav-nav__item--mega > details-disclosure > details[open]').forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });

          details.setAttribute('open', '');
          requestAnimationFrame(syncRavHeaderLayer);
        };

        const scheduleClose = () => {
          cancelClose();

          closeTimer = window.setTimeout(() => {
            if (!summary.matches(':hover') && !mega.matches(':hover') && !details.matches(':focus-within')) {
              details.removeAttribute('open');
              requestAnimationFrame(syncRavHeaderLayer);
            }
          }, 240);
        };

        summary.addEventListener('mouseenter', openMenu);
        summary.addEventListener('mouseleave', scheduleClose);
        mega.addEventListener('mouseenter', cancelClose);
        mega.addEventListener('mouseleave', scheduleClose);
        details.addEventListener('focusin', openMenu);
        details.addEventListener('focusout', () => window.setTimeout(scheduleClose, 0));
      });
    }

    syncRavHeaderLayer();
  }

  initRavHeader();

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.rav-mobile-menu[open]').forEach((drawer) => drawer.removeAttribute('open'));
    document.documentElement.classList.remove('rav-menu-open');
    document.querySelectorAll('.rav-nav__item--mega > details-disclosure > details[open]').forEach((details) => details.removeAttribute('open'));
    document.querySelectorAll('.rav-region details[open]').forEach((details) => details.removeAttribute('open'));

    requestAnimationFrame(syncRavHeaderLayer);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initRavHeader(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
